import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/users',
    name: 'user',
    meta: { middleware: authenticate },
    component: () => import('@/pages/security/user')
  }
]
